module.exports = __webpack_public_path__ + "img/next360-rounded.d864ab12.svg";